const BASE_URL = 'https://cinealert-utah-production.up.railway.app/api';

function getToken() {
  return localStorage.getItem('cinealert_token');
}

function setToken(token) {
  localStorage.setItem('cinealert_token', token);
}

function removeToken() {
  localStorage.removeItem('cinealert_token');
}

async function apiFetch(path, options = {}) {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json', ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(`${BASE_URL}${path}`, { ...options, headers });
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.error || `Request failed: ${res.status}`);
  }
  return data;
}

// Auth
async function signup(name, email, phone, password, notificationPreference = 'email', smsConsent = false) {
  const data = await apiFetch('/auth/signup', {
    method: 'POST',
    body: JSON.stringify({ name, email, phone, password, notification_preference: notificationPreference, sms_consent: smsConsent })
  });
  if (data.token) setToken(data.token);
  return data;
}

async function login(email, password) {
  const data = await apiFetch('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password })
  });
  if (data.token) setToken(data.token);
  return data;
}

async function getMe() {
  return apiFetch('/auth/me');
}

function logout() {
  removeToken();
}

// Movies
async function getMovies(filter = '') {
  const query = filter ? `?filter=${filter}` : '';
  return apiFetch(`/movies${query}`);
}

// Watchlist
async function getWatchlist() {
  return apiFetch('/watchlist');
}

async function addToWatchlist(movieId) {
  return apiFetch('/watchlist', {
    method: 'POST',
    body: JSON.stringify({ movie_id: movieId })
  });
}

async function removeFromWatchlist(movieId) {
  return apiFetch(`/watchlist/${movieId}`, { method: 'DELETE' });
}

async function updateNotificationPreference(preference) {
  return apiFetch('/auth/notification-preference', {
    method: 'PATCH',
    body: JSON.stringify({ preference })
  });
}

async function updatePhone(phone) {
  return apiFetch('/auth/phone', {
    method: 'PATCH',
    body: JSON.stringify({ phone })
  });
}

async function forgotPassword(email) {
  return apiFetch('/auth/forgot-password', {
    method: 'POST',
    body: JSON.stringify({ email })
  });
}

async function resetPassword(token, password) {
  return apiFetch('/auth/reset-password', {
    method: 'POST',
    body: JSON.stringify({ token, password })
  });
}

async function deleteAccount() {
  return apiFetch('/auth/account', { method: 'DELETE' });
}

async function submitContact(name, email, message) {
  return apiFetch('/contact', {
    method: 'POST',
    body: JSON.stringify({ name, email, message }),
  });
}

export default {
  signup,
  login,
  logout,
  getMe,
  getMovies,
  getWatchlist,
  addToWatchlist,
  removeFromWatchlist,
  updateNotificationPreference,
  updatePhone,
  forgotPassword,
  resetPassword,
  deleteAccount,
  submitContact,
  getToken,
  isLoggedIn: () => !!getToken()
};
